export function submitEditCustomerProduct()
{
    return({
        type:"EDIT_CUSTOMER_PRODUCT_SUBMIT"
    })
}